import {
    parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates,
} from 'nuqs';
import { useCallback } from 'react';

const popupModes = [
    'view',
    'edit',
    'details',
    'copy',
    'changes',
    'image',
] as const;

export type PopupMode = (typeof popupModes)[number];

type OpenPopupOptions = {
    mode: PopupMode;
    itemId?: string | null;
    imageIndex?: number | null;
};

const popupQueryOptions = {
    history: 'push' as const,
};

export const usePopupQueryParams = () => {
    const [popupQuery, setPopupQuery] = useQueryStates({
        mode: parseAsStringLiteral(popupModes),
        itemId: parseAsString,
        imageIndex: parseAsInteger,
    }, popupQueryOptions);

    const open = useCallback(({
        mode,
        itemId = null,
        imageIndex = null,
    }: OpenPopupOptions) => {
        return setPopupQuery({
            mode,
            itemId,
            imageIndex,
        });
    }, [setPopupQuery]);

    const close = useCallback(() => {
        return setPopupQuery({
            mode: null,
            itemId: null,
            imageIndex: null,
        });
    }, [setPopupQuery]);

    const isMode = useCallback((mode: PopupMode) => popupQuery.mode === mode, [popupQuery.mode]);

    return {
        ...popupQuery,
        open,
        close,
        isMode,
        hasItemId: popupQuery.itemId != null && popupQuery.itemId !== '',
    };
};
